import type {ReactAction} from '@netx/core/bootstrap';
import {faUsersCog} from '@netx/core-icons';
import {canShareSavedSearchWithTeam} from '../enablers';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import {type SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionTeamAccessIcon = faUsersCog;

/**
 * Saved search share team access
 * @param params
 * @returns Action
 */
export const searchSavedActionTeamAccess = (
	savedCart?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-share-team-access',
	cb: () => dispatcher.trigger(SEARCH_SAVED_EVENT.SHARE_TEAM_ACCESS, savedCart),
	enableTest: () => canShareSavedSearchWithTeam(savedCart),
	icon: searchSavedActionTeamAccessIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.SHARE_TEAM_ACCESS;
	},
	...params,
});

export default searchSavedActionTeamAccess;
